<div class="doc-container">
  <img width="175" src="assets/images/complete.svg">
  <h2>Firma completata!</h2>
  <div class="documents">
    <a class="doc-btn" [href]="infocertBase + doc.url" target="_blank" *ngFor="let doc of amlService.signedDocuments"
      mat-stroked-button color="primary" class="doc-buttons">
      <mat-icon svgIcon="pdf"></mat-icon>
      {{doc.name}}
    </a>
  </div>
</div>